import type { HTMLAttributes } from 'react';
import styles from './Spinner.module.css';

type SpinnerSize = 'sm' | 'md' | 'lg';

interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: SpinnerSize;
}

export const Spinner = ({
  size = 'md',
  className = '',
  ...props
}: SpinnerProps) => {
  const classNames = [
    styles.spinner,
    styles[size],
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classNames} role="status" aria-label="Loading" {...props}>
      <div className={styles.circle} />
    </div>
  );
};

